import React, { useState } from "react";
import { Form } from "../components/Form";
import ModalCertificate from "../components/ModalCertificate";

const Benefits = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [responseStatus, setResponseStatus] = useState("");

    const handleOpenModal = (data, status) => {
        setData({ url: data?.certificate, vin: data?.vin });
        setResponseStatus(status);
    };
    const handleCloseModal = () => {
        setData(null);
        setResponseStatus("");
    };

    return (
        <>
            <section className='fleet-certificate__container'>
                <div className='main-container'>
                    <div className='content-wrapper'>
                        <h1>Descarga de Certificado de Seguridad</h1>
                        <p>
                            Obtén el Certificado de Seguridad de los Vehículos
                            de tu flota de manera online e inmediata.
                        </p>
                    </div>

                    <Form
                        handleOpenModal={handleOpenModal}
                        setLoading={setLoading}
                    />
                </div>
                {loading && (
                    <>
                        <div className='bg-overlay'></div>
                        <div className='spinner-container'>
                            <div className='spinner'></div>
                        </div>
                    </>
                )}
            </section>

            <ModalCertificate
                data={data}
                onCloseModal={() => handleCloseModal()}
                status={responseStatus}
            />
        </>
    );
};

export default Benefits;
